/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const getBuildWeekData = params => {

    const buildWeekData = formatGivenDate( params.data.buildWeek, 'YYYY-MM-DD' );

    return buildWeekData;

};
function getRowClass ( params ) {

    if ( params.data.orderCodeExists ) {

        return 'selected-row';

    }
    return null;

}

const colDefsPoolOrder = [

    {
        field: 'type',
        headerName: 'Type',
        sortable: true,
        filter: true,
        width: 40
    },
    {
        field: 'orderCode',
        headerName: 'Order Code',
        sortable: true,
        filter: true,
        width: 63
    },
    {
        field: 'qty',
        headerName: 'Qty',
        sortable: true,
        filter: true,
        width: 50
    }
];

const colDefsSalesOrder = [

    {
        field: 'type',
        headerName: 'Type',
        sortable: true,
        filter: true,
        width: 40,
        cellRenderer: params => {

            if ( params.data.orderCodeExists ) return ( <span>*{params.value}</span> );

            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'orderCode',
        headerName: 'Order Code',
        sortable: true,
        filter: true,
        width: 63,
        cellRenderer: params => {

            if ( params.value ) {

                return ( <Link to={`/${params.data.unitName}/order/availability?constraintkey=${params.data.constraintKey.trim()}&week=${formatGivenDate( params.data.buildWeek, 'YYYY-MM-DD' )}&constrainttype=${params.data.constraintType.trim()}`}>{params.value}</Link> );

            }

            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'qty',
        headerName: 'Qty',
        sortable: true,
        filter: true,
        width: 50
    },
    {
        field: 'buildWeek',
        headerName: 'Build Week',
        sortable: true,
        filter: true,
        width: 50,
        valueGetter: getBuildWeekData
    }

];

export const PoolOrderCodesTable = props => (

    <section className="atp-search-result-panel pool-order-exchange-detail-result-panel ">
        Pool Order Codes - {props.poolOrderCode}
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefsPoolOrder}
                rowData={props.list}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

PoolOrderCodesTable.propTypes = {
    list: PropTypes.array.isRequired,
    poolOrderCode: PropTypes.string
};

export const SalesOrderCodesTable = props => (

    <section className="atp-search-result-panel pool-order-exchange-detail-result-panel ">
        Sales Order Codes - {props.salesOrderCode}
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefsSalesOrder}
                rowData={props.list}
                onGridReady={onGridReady}
                getRowClass={getRowClass}
            />
        </div>

    </section>
);

SalesOrderCodesTable.propTypes = {
    list: PropTypes.array.isRequired,
    salesOrderCode: PropTypes.string
};
